import produce from 'immer';

const INITIAL_STATE = {
  postoBicosVazao: [],
};

export default function locomotivaRegistration(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@locomotivaRegistration/LOCACOMOTIVA_POSTOBICOSVAZAO': {
        draft.postoBicosVazao = action.payload.value;
        break;
      }

      case '@locomotivaRegistration/LOCACOMOTIVA_RESETVALUES': {
        draft.postoBicosVazao = [];
        break;
      }

      default:
    }
  });
}
